const carDocumentListGridConfig = {
    columns: [
        {
            id: 1,
            width: 275,
            selector: 'documentName',
            name: 'Тип документ',
            sequenceNumber: 1,
            type: 'string'
        },
        {
            id: 2,
            width: 180,
            selector: 'startDate',
            name: 'Валиден от',
            sequenceNumber: 2,
            type: 'date'
        },
        {
            id: 3,
            width: 180,
            selector: 'endDate',
            name: 'Валиден до',
            sequenceNumber: 3,
            type: 'date'
        }
    ],
    props: {
        headerRowHeight: 50,
        rowHeight: 52,
        tableHeight: 600,
        filterable: false,
        selectableColumn: {
            show: true,
            icon: 'fa fa-file-alt',
            width: 90
        }
    }
};

export default carDocumentListGridConfig;
